import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';
import { PropertyDelegate } from '../PropertyService/property.delegate';
import { PropertyService } from '../PropertyService/property.service';

export class PropertyServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): PropertyService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new PropertyDelegate(httpProvider);

        return new PropertyService(delegate, authenticationService);
    }
}